// src/lib/queryClient.js

import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 1. Creamos un único QueryClient con opciones por defecto
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tiempo durante el cual los datos se consideran "frescos" (15 min)
      staleTime: 15 * 60 * 1000,
      // Tiempo que React Query mantiene la caché total (30 min)
      cacheTime: 30 * 60 * 1000,
      // Reintenta hasta 2 veces las peticiones que fallen
      retry: 2,
      // No refetch on window focus por defecto
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Reintenta mutaciones fallidas 1 vez
      retry: 1,
    },
  },
});

// 2. Componente envoltorio que suministra el provider y los devtools
export function ReactQueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
